import React from 'react';
import { Grid } from '@mui/material';
import { Icon, IconButton } from '@elements';
import close from '@images/close.image.svg';
import { StyledPopupTitleTypography } from './popup-title.styled';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var PopupTitle = function PopupTitle(_ref) {
  var children = _ref.children,
      handleClose = _ref.handleClose;
  var titleContent = typeof children === 'string' ? /*#__PURE__*/_jsxs(StyledPopupTitleTypography, {
    variant: "h3",
    children: [children, "StyledPopupTitleTypography"]
  }) : children;
  return /*#__PURE__*/_jsxs(Grid, {
    container: true,
    spacing: 2,
    flexWrap: "nowrap",
    alignItems: "flex-start",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(Grid, {
      item: true,
      xs: 12,
      children: titleContent
    }), /*#__PURE__*/_jsx(Grid, {
      item: true,
      position: "absolute",
      top: "4px",
      right: "12px",
      children: /*#__PURE__*/_jsx(IconButton, {
        size: "small",
        onClick: handleClose,
        children: /*#__PURE__*/_jsx(Icon, {
          height: 28,
          src: close,
          width: 28
        })
      })
    })]
  });
};

PopupTitle.displayName = 'PopupTitle';
export { PopupTitle };